module.exports = require("core-js-pure/features/url-search-params");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/url-search-params.js
// module id = 496
// module chunks = 13